import PropTypes from 'prop-types';
import image from './image';
import url from './url';

export default PropTypes.shape({
  name: PropTypes.string,
  teaseImage: image,
  url,
});
